import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchFormData,
    setSignUpBasicData,
    configureMailRequirement,
    configureDomainRequirement,
    setOTPVerified,
    setStepNumber,
} from '../../store/signup/signupAction';
import { setNavMenu } from '../../store/menu/menuAction';
import {
    NEED_DOMAIN_STEPS,
    NEED_MAIL_SERVER_STEPS,
    INFINCE_ONLY,
} from '../../utilities/constants';
import Header from '../../components/Header';

/**
 * Link verification component
 * @param {*} param0
 */
const LinkVerification = ({
    fetchFormData,
    setSignUpBasicData,
    configureMailRequirement,
    configureDomainRequirement,
    setOTPVerified,
    setStepNumber,
    setNavMenu,
}) => {
    let { id, token } = useParams();
    const history = useHistory();
    const [verifiedStatus, setVerifiedStatus] = useState('processing');

    useEffect(() => {
        fetchFormData(id, token).then((res) => {
            if (res.status === 'success') {
                setVerifiedStatus('success');
                setSignUpBasicData(get(res, 'form'));
                configureMailRequirement(
                    get(res, 'lead.need_mail_server', 'no') === 'yes'
                        ? true
                        : false
                );
                configureDomainRequirement(
                    get(res, 'lead.need_domain', 'no') === 'yes' ? true : false
                );
                setOTPVerified(true);
                setStepNumber(3);

                if (get(res, 'lead.need_domain', 'no') === 'yes') {
                    setNavMenu(NEED_DOMAIN_STEPS);
                    history.push(
                        `/registration/${get(NEED_DOMAIN_STEPS, '2.route', '')}`
                    );
                } else if (get(res, 'lead.need_mail_server', 'no') === 'yes') {
                    setNavMenu(NEED_MAIL_SERVER_STEPS);
                    history.push(
                        `/registration/${get(
                            NEED_MAIL_SERVER_STEPS,
                            '2.route',
                            ''
                        )}`
                    );
                } else {
                    setNavMenu(INFINCE_ONLY);
                    history.push(
                        `/registration/${get(INFINCE_ONLY, '2.route', '')}`
                    );
                }
            } else {
                setVerifiedStatus('failed');
            }
        });
    }, [
        id,
        token,
        setVerifiedStatus,
        configureMailRequirement,
        configureDomainRequirement,
        setOTPVerified,
        setStepNumber,
        fetchFormData,
        history,
        setSignUpBasicData,
        setNavMenu,
    ]);
    /**
     * Renders verification text
     * @param {*} status
     */
    const renderText = (status) => {
        if (status === 'success') {
            return (
                <div className="type1-container email-varification-successful">
                    <h1>Email verified successfully.</h1>
                    <p>
                        Please wait while we redirect you to the signup process.
                    </p>
                </div>
            );
        } else if (status === 'failed') {
            return (
                <div className="type1-container email-varification-failed">
                    <h1>Email verification failed.</h1>
                    <p>Please check the URL you have entered and try again.</p>
                </div>
            );
        }
    };
    return (
        <div className="container">
            <Header />
            {renderText(verifiedStatus)}
        </div>
    );
};

const mapStateToProps = (store) => ({});
const mapDispatchToProps = {
    fetchFormData,
    setSignUpBasicData,
    configureMailRequirement,
    configureDomainRequirement,
    setOTPVerified,
    setStepNumber,
    setNavMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkVerification);
